import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
 
import './header.css';
    
function NavBarH() {
  
    const [activeLink, setClick] = useState(false);
     const [scrolled, setScrolled] = useState(false);
  
     const closeMobileMenu = () => setClick(false);
  
     
     
  
    useEffect(() => {
      const onScroll = () => {
        if (window.scrollY > 20) {
          setScrolled(true);
          
        } else {
          setScrolled(false);
        }
        
      }
    
   
    window.addEventListener("scroll", onScroll);
   
    return () => window.removeEventListener("scroll", onScroll);
  }, [])
  
   
  
    return (
       <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
       
        
       <Container className="containerCss">  
        
        <Navbar.Brand href="/">
           <Nav.Link href="/" className={activeLink === 'home' ? 'nav-links' : 'navbar-link'} onClick={() => closeMobileMenu('Home')}>Uma História da Península</Nav.Link> 
           
               
          </Navbar.Brand>
   
           <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"> </span>
          </Navbar.Toggle>  
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="">
   
   
            <Nav.Link href="/DivulgacaoCientifica" className={activeLink === 'DivulgacaoCientifica' ? 'navbar-link' : 'navbar-link'} onClick={() => closeMobileMenu('DivulgacaoCientifica')}>Divulgação científica</Nav.Link>
            <Nav.Link href="/Convenios" className={activeLink === 'Convenios' ? 'navbar-link' : 'navbar-link'} onClick={() => closeMobileMenu('Convenios')}>CONVÊNIOS</Nav.Link>
              <Nav.Link href="/BancodeDados" className={activeLink === 'BancodeDados' ? 'navbar-link' : 'navbar-link'} onClick={() => closeMobileMenu('BancodeDados')}>BANCO DE DADOS</Nav.Link>
              {/* <Nav.Link href="/Documentos" className={activeLink === 'Documentos' ? 'nav-links' : 'navbar-link'} onClick={() => closeMobileMenu('Documentos')}>Documentos</Nav.Link> */}
  
              <Nav.Link href="/Eventos" className={activeLink === 'Eventos' ? 'navbar-link' : 'navbar-link'} onClick={() => closeMobileMenu('Eventos')}>EVENTOS</Nav.Link>
              <Nav.Link href="/FaleConosco" className={activeLink === 'FaleConosco' ? 'navbar-link' : 'navbar-link'} onClick={() => closeMobileMenu('FaleConosco')}>Fale Conosco</Nav.Link>
               <Nav.Link href="/SobreNos" className={activeLink === 'SobreNos' ? 'nav-links' : 'navbar-link'} onClick={() => closeMobileMenu('SobreNos')}>SOBRE NÓS</Nav.Link>
  
             
              
              
            </Nav>
                   
          </Navbar.Collapse>
          </Container> 
           
      </Navbar>
  
     )
  }


export default NavBarH;
